// 简体中文表格（机器翻译，未经人工审校 — ruling G4）。
// The Simplified Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  loading: "加载中…",
  building: "正在生成…",
  layingOut: "正在排版…",
  makingFile: "正在生成文件…",
  timedOut: "生成 10 秒未完成，已重新开始——请减少字符或换字体",
  loadFailed: "无法加载——请尝试刷新页面",
  triangles: (n) => `${n.toLocaleString('en-US')} 个三角形`,
  loading3d: "正在加载 3D 视图…",
  load3dFailed: "3D 视图打不开——请重试",
  fontLoading: (family, got, total) => (total > 0 ? `正在加载 ${family} ${got} / ${total} MB` : `正在加载 ${family} ${got} MB`),
  fontLinkNote: (family) => `无法加载 ${family}——请检查网络连接 · 继续使用当前字体`,
  more: (n) => `还有 ${n} 项`,
  placeholder: {
    name: "例如 Big",
    phone: "0812345678",
  },
  emptyEl: "（空）",
  addTitle: "添加文字或图标",
  resetWarning: "自定义排版已重置，添加的部件已被移除（按 ↶ 可撤销）",
  hint: {
    touch: "在牌子上任意位置拖动即可移动选中的部件——不必按在字母上",
    mouse: "用鼠标拖动部件，或使用方向键（Shift = 每次 1 毫米）",
  },
  ariaPreview: {
    front: "2D 预览",
    back: "2D 预览，背面",
  },
  iconSize: "图标大小",
  textSize: "文字大小",
  roleLabel: {
    name: "名字",
    phone: "电话",
    text: "文字",
    icon: "图标",
  },
  fieldLabel: {
    name: "宠物名字",
    phone: "电话号码",
    text: "文字",
    icon: "图标",
  },
  face: {
    back: "（背面）",
  },
  copied: "链接已复制——可直接粘贴到聊天中",
  copyManual: "自动复制没有成功——请长按上方链接手动复制",
  shape: {
    circle: "圆形",
    bone: "骨头",
    heart: "心形",
    paw: "爪印",
    cat: "猫头",
  },
  template: {
    name: "只放名字",
    "name-phone": "名字 + 电话",
    "name-front-phone-back": "名字在正面，电话在背面",
    "icon-name": "图标 + 名字",
    "icon-name-phone-back": "图标 + 名字，电话在背面",
  },
  icon: {
    paw: "爪印",
    heart: "心形",
    bone: "骨头",
    star: "星",
    fish: "鱼",
    cat: "猫",
    dog: "狗",
    phone: "电话",
  },
  preset: {
    dog: "狗",
    cat: "猫",
    paw: "爪印",
    heart: "心形",
  },
  engravedNote: "雕刻字母与牌子同色——想要第二种颜色的字母请选“凸起”",
  singleColour: "单色——任何打印机都能打",
  threeMf: (tagName, textName, z, n) => `3MF 文件：牌子 = 耗材 1（${tagName}），字母 = 耗材 2（${textName}）· 单喷头：在 Z = ${z} 毫米处换色（第 ${n} 层 @0.2 毫米）——孔边一圈也会用字母的颜色打印`,
  title: "宠物挂牌",
  lineNote: "要下载文件请在普通浏览器中打开 — 做好的设计会一并带过去",
  lineOpen: "在浏览器中打开",
  retryNote: "加载失败 — 点按重新加载",
  faceBtn: {
    front: "正面",
    back: "背面",
  },
  ariaFace: {
    front: "正面",
    back: "背面",
  },
  faceNote: "从背面看 — 文字方向正常 · 背面固定雕深 0.6 毫米",
  gTag: "挂牌样式",
  presetsLabel: "从预设开始",
  ariaPresets: "预设",
  templatesLabel: "版式",
  ariaTemplates: "版式",
  gShape: "形状",
  shapesLabel: "挂牌形状",
  ariaShapes: "挂牌形状",
  sizeLabel: "挂牌大小",
  sizeHint: "参考大小：10 泰铢硬币 = 26 毫米",
  sizeRanges: "猫/小型犬 25–30 · 中型犬 30–38 · 大型犬 38 毫米以上",
  holeLabel: "挂绳孔",
  holes: {
    inside: "牌内开孔",
    tab: "顶部挂耳",
  },
  thickLabel: "厚度",
  gColour: "颜色",
  modeLabel: "文字样式",
  modes: {
    raised: "凸起",
    engraved: "雕刻",
  },
  colourLabel: {
    tag: "挂牌颜色",
    text: "文字颜色",
  },
  gAdv: "自己调整位置",
  advanced: "自定义",
  backToSimple: "← 返回简单模式",
  resetTemplate: "重置为模板",
  cancel: "取消",
  confirmReset: "好，重置",
  ariaChips: "挂牌上的部件",
  ariaAdd: "添加部件",
  addText: "＋ 文字",
  ariaSheet: "调整选中的部件",
  sheetEmpty: "点按挂牌上的部件或上方的芯片，选中要调整的部件",
  emPre: "大小：",
  mmPost: " 毫米",
  nudgePre: "移动 0.25 毫米 · 旋转 ",
  nudgePost: "°（点按 = 15°，长按 = 每次 1°）",
  ariaNudge: {
    left: "向左移动",
    up: "向上移动",
    down: "向下移动",
    right: "向右移动",
  },
  ariaRot: {
    ccw: "逆时针旋转",
    cw: "顺时针旋转",
  },
  deletePiece: "删除这个部件",
  aboutH2: "狗猫挂牌 — 名字 + 电话，双色 3D 打印",
  aboutP: "为狗狗和猫咪设计挂牌：填入宠物名字和主人电话，从市面上买得到的耗材中选形状、图标和两种颜色（挂牌 + 文字），然后免费下载多色打印用的 3MF 或单色打印用的 STL。浏览器里免费用，无需安装。",
  printLi1: "用 PLA 或 PETG 打印，层高 0.2 毫米",
  printLi2: "用 AMS/CFS 机器打印两色 — 3MF 已把挂牌设为 1 号料、凸起文字设为 2 号料，实际颜色在切片软件里选",
  printLi3: "单喷头打印机：在文字颜色下方给出的 Z 高度处暂停换料",
  footerNote: "每个挂牌都经过水密检查 — 穿孔和孔周加固圈可直接使用",
  ariaDownloads: "下载",
  dlstl: "下载 STL",
  ariaShareUrl: "这个设计的链接",
  ariaClose: "关闭",
  // a link that cannot open (src/doc.js decodeFragment's codes, worded by src/ui/share-ui.js)
  link: {
    bad: "此链接无法使用 — 请重新获取链接",
    newer: "此链接来自更新的版本",
  },
  // What the worker reports, in words (ruling R9: the worker speaks codes, src/worded.js says them)
  worker: {
    fontLoad: "字体加载失败 — 请重试",
    face: {
      front: "正面",
      back: "背面",
    },
    tooDetailed: (face) => `${face}的文字过于精细 — 请减少文字或更换字体`,
    missingChars: (label, chars) => `${label}：此字体没有 ${chars}`,
    badChar: (label, point) => `${label}：含有无法使用的字符（${point}）— 请删除后重新输入`,
    leadingMark: (label) => `${label}以悬空的元音或声调符号开头 — 请在前面加上辅音`,
    empty: "下载前请输入宠物的名字",
    tooMany: (max) => `每面最多 ${max} 个元素`,
    quoteText: (text) => `“${text}”`,
    quoteIcon: (name) => `${name}图标`,
    outside: (what) => `${what}超出了吊牌边缘`,
    onHole: (what) => `${what}压到了挂环孔`,
    overlap: (what) => `${what}与其他元素太近或重叠`,
    tooThin: (what) => `${what}太小，打印不清楚`,
    tooThinBack: (what, factor) => `${what}对背面来说太小（背面约需正面的 ${factor} 倍大）`,
    tooThinBackFit: (what) => `${what}太小，无法刻在背面`,
    tooThinTag: (mm) => `吊牌太薄，无法在背面刻字 — 请把厚度调到 ${mm} 毫米以上`,
    holeWall: "挂环孔周围的边太薄 — 请加大吊牌或更换孔的样式",
    noFit: {
      front: "文字对这个尺寸的吊牌来说太长",
      back: "背面文字对这个尺寸的吊牌来说太长",
    },
    wayOut: (why, way) => `${why} — ${way}`,
    way: {
      plain: "请加大吊牌或缩短文字",
      phone: "请加大吊牌、缩短文字，或把电话号码移到背面",
    },
    phoneToBack: "把电话号码移到背面",
  },
  // the name on this page's share card (R69): the page opens with no name, as it always has — the card shows one, in Latin (no bundled family has kana or Han)
  cardName: "Mochi",
};
export default S;
